<template>
  <v-container fill-height grid-list-md text-xs-center>
    <v-layout row wrap align-center>
      <v-flex xs6 offset-xs3>
        <v-form
          @submit.prevent="submiResetForm"
        >
          <v-container>
            <div class="container-login">
              <v-flex xs8 offset-xs2 style="padding-top: 150px;" class="box-white">
                <v-text-field
                  v-model="password.new_password1"
                  required
                  color="#091D3B"
                  label="New Password"
                  box
                  :type="'password'"
                >
                </v-text-field>
                <v-text-field
                  v-model="password.new_password2"
                  required
                  label="Confirm Password"
                  box
                  :type="'password'"
                  color="#091D3B"
                >
                </v-text-field>
                <v-btn
                  block
                  type="submit"
                  @click.prevent="submitResetForm"
                  class="button-style-blue"
                  dark
                >
                  Change Password
                </v-btn>
              </v-flex>
            </div>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  data() {
    return {
      password: {},
    }
  },
  methods: {
    ...mapActions(['passwordResetConfirm']),
    submitResetForm() {
      if (!this.password.new_password1 || !this.password.new_password2) {
        this.$toastr('error', 'Fields may not be blank.', 'error');
        return;
      }
      const data = Object.assign(this.password, {uid: this.$route.params.uid, token: this.$route.params.token})
      this.passwordResetConfirm(data)
        .then((data) => {
          this.$router.push({ name: 'login' });
          this.$toastr('info', 'Password reset successful, you can login now.', 'info');
        })
        .catch((errors) => {
          this.$toastr('error', Object.values(errors), 'error');
        });
    }
  }
}
</script>